import { connect } from "react-redux";

import { getLogsList, getReferences } from "actions/action_logs";
import { getDropdownAccounts } from "actions/dropdown_accounts";
import ActionLogs from "./ActionLogs";


const mapStateToProps = ({ auth, action_logs, dropdown_accounts }) => ({
    service: auth.service,
    appType: auth.appType,

    managerList: action_logs.managerList,
    actionList: action_logs.actionList,
    userList: action_logs.userList,
    referencesFetched: action_logs.referencesFetched,

    data: action_logs.list,
    count: action_logs.count,
    page: action_logs.page,
    perPage: action_logs.perPage,
    loading: action_logs.loading,

    accounts: dropdown_accounts.items,
    accountsFetched: dropdown_accounts.fetched,
});

export default connect(mapStateToProps, {
    getReferences,
    getLogsList,
    getAccounts: getDropdownAccounts,
})(ActionLogs);